export const
COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION = 'COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION',
COMPLAINT_POSITIONS_ADD_SINGLE_COMPLAINT_POSITION = 'COMPLAINT_POSITIONS_ADD_SINGLE_COMPLAINT_POSITION',
EDIT_COMPLAINT_POSITION = 'EDIT_COMPLAINT_POSITION',
DELETE_COMPLAINT_POSITION = 'DELETE_COMPLAINT_POSITION';


// WEBPACK FOOTER //
// ./src/types/ComplaintPositions.js